import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-sent-message-dialog',
  templateUrl: './sent-message-dialog.component.html',
  styleUrls: ['./sent-message-dialog.component.css']
})
export class SentMessageDialogComponent implements OnInit {

  sent_message_tittle: string = "Mensaje Enviado";
  sent_message: string = "Tu mensaje ha sido enviado";

  sent_message_tittle_error: string = "Mensaje No Enviado";
  sent_message_error: string = "No Existen Candidatos para el filtro seleccionado";

  error: boolean = false;

  constructor(@Inject(MD_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.error = this.data;
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/sent-message-dialog/sent-message-dialog.component.ts